import { render, staticRenderFns } from "./RepeaterBlock.vue?vue&type=template&id=bdc44544&"
import script from "./RepeaterBlock.vue?vue&type=script&lang=js&"
export * from "./RepeaterBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdc44544')) {
      api.createRecord('bdc44544', component.options)
    } else {
      api.reload('bdc44544', component.options)
    }
    module.hot.accept("./RepeaterBlock.vue?vue&type=template&id=bdc44544&", function () {
      api.rerender('bdc44544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetofferdetail/components/RepeaterBlock.vue"
export default component.exports